/**
 * Style files — the Order Book list (garment Increment 1).
 *
 * @see prototype/garment/style-file.html — V1.1 baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StylesListPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/")({
  component: StylesRoute,
});

function StylesRoute() {
  return (
    <WorkspaceShell breadcrumbs={[{ label: "Merchandising", to: "/" }, { label: "Style files" }]}>
      <StylesListPage />
    </WorkspaceShell>
  );
}
